<script setup>
import AppLayout from "@/Layouts/AppLayout.vue";
import {Link} from '@inertiajs/inertia-vue3';

defineProps({
  emails: Array,
});
</script>

<template>
  <AppLayout title="Workorders">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        <span>Email Templates</span>
      </h2>
    </template>

    <div class="mx-auto py-10 sm:px-6 lg:px-8">
      <div class="bg-white relative shadow-md sm:rounded-lg overflow-hidden">
        <div class="overflow-x-auto">
          <table class="w-full text-sm text-left text-gray-500">
            <thead class="text-xs uppercase bg-gray-50">
            <tr>
              <th scope="col" class="px-4 py-3">Template Name</th>
              <th scope="col" class="px-4 py-3">Description</th>
              <th scope="col" class="px-4 py-3">Actions</th>
            </tr>
            </thead>
            <tbody>
            <tr class="cursor-pointer" v-for="email in emails">
              <td class="px-4 py-3 break-words" v-text="email.name"></td>
              <th scope="row" class="px-4 py-3 font-medium text-gray-900 break-words" v-text="email.description">
              </th>
              <td class="px-4 py-3 break-words">
                <Link :href="route('admin.email-templates.edit', {email_template: email.name})" class="fa fa-eye p-1"
                      :title="`View Template`">
                </Link>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </AppLayout>
</template>
